import React, { useEffect, useRef, useState } from "react";

import TableLoader from "../../shared/TableLoader";
import NoDataFound from "../../shared/NoDataFound";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { SetComponentId, SetSalesUsersList } from "../../redux/counterSlice";
import API from "../../services/api";
import { BrandsTypes, capitalizeFirstLetter } from "../../utils/constants";
import nationalIcon from "../../assets/images/national-sales-icon.svg";
import localIcon from "../../assets/images/local-sales-icon.svg";
import localTNIcon from "../../assets/images/local-tamil-icon.svg";
import metroIcon from "../../assets/images/metro-sales-icon.svg";
import alphaIcon from "../../assets/images/alpha-sales-icon.svg";
import salesProfile from "../../assets/images/salesProfile.png";
import linkIcon from "../../assets/images/browse-icon.svg";

import { redirect, useNavigate } from "react-router";
import EffortAnalysis from "./EffortAnalysis";
const mainLevelClasses = [
  "",
  "first-level",
  "second-level",
  "third-level",
  "fourth-level",
];
const subLevelClasses = [
  "",
  "level-one",
  "level-two",
  "level-three",
  "level-four",
];

function EffortAnalysisDashboard() {
  const currentDate = new Date();
    currentDate.setDate(1);
    currentDate.setHours(0, 0, 0, 0);
  const dispatch = useDispatch();
  dispatch(SetComponentId(34));
  const salesUsersList = useSelector((state) => state.Head.subordinates);
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [currentTree, setCurrentTree] = useState({});
  const [selectedNewUserType, setselectedNewUserType] = useState(1);
  const [selectedMonth, setSelectedMonth] = useState(currentDate);
  const [teamFilterShow, setTeamFilterShow] = useState(false);
  const [initialRender, setIntialRender] = useState(true);
  const [showEffort, setShowEffort] = useState(false)
  const [sales_person_id, setSales_person_id] = useState(false)

  const navigate = useNavigate();

  const getTree = async () => {
    try {
      setLoader(true);
      let reqObj = { selectedNewUserType, selectedMonth };
      let res = await API({
        url: "/effort_analysis/get-tree",
        method: "POST",
        responseType: "json",
        data: reqObj,
      });
      if (res.code === 200) {
        setData(res.data.arrayResult);
        if (res.data.new_user_type === -1) {
          setTeamFilterShow(true);
        }
      }
      setIntialRender(false);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };
  const handleElaborate = async (subordinates, sales_person_id) => {
    try {
      let headIndex = null;
      data.map((array, index) => {
        if (array.find((item) => item.sales_person_id === sales_person_id)) {
          headIndex = index;
        }
      });
      // setData([...data.filter((array, index) => index <= headIndex)]);
      let res = await API({
        url: "/effort_analysis/get-next-level",
        method: "POST",
        responseType: "json",
        data: { subordinates, selectedMonth },
      });
      if (res.code === 200) {
        setData([
          ...data.filter((array, index) => index <= headIndex),
          res.data,
        ]);
      }
      // Scroll to the bottom after a small delay to ensure rendering
      setTimeout(() => {
        document
          ?.getElementById("scrollToEnd")
          ?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } catch (error) {
      console.error("Error @ nextLevelSubordinates", error);
    }
  };
  useEffect(() => {
    if (salesUsersList.length === 1) {
      localStorage.setItem("selectedSalesList", [salesUsersList[0].value]);
      navigate("/home/sales/effort", {
        state: {
          salesPerson_id: JSON.stringify(salesUsersList[0].value),
        },
      });
    }
    getTree();
  }, []);
  useEffect(() => {
    if (!initialRender) getTree();
  }, [selectedNewUserType, selectedMonth]);
  const handleMoveToEffort = async (sales_person_id) => {
    let selectedList = JSON.parse(localStorage.getItem("selectedSalesList")) || []
    selectedList = [...new Set([sales_person_id, ...selectedList])]
    localStorage.setItem(
      "selectedSalesList",
      JSON.stringify(selectedList)
    );
    setShowEffort(!showEffort)
    setSales_person_id(sales_person_id)
    // navigate("/home/sales/effort", {
    //   state: {
    //     salesPerson_id: sales_person_id,
    //   },
    // });
  };
  const handleMonthChange = (date) => {
    setSelectedMonth(date);
  };
  return (
    <>
    {!showEffort ? <div class="effort-analyis mainTree">
      <div class="tree-dashboard">
        <div class="title-menu">
            <div className="title-month">
              <h3>
                <i class="icon">
                  <img src="assets/images/organization-tree.svg" alt="" />
                </i>{" "}
                <span>Sales Department Tree</span>
              </h3>
              <div class="view-navigate dshbrdMntSlc">
                <DatePicker
                  selected={selectedMonth}
                  onChange={handleMonthChange}
                  dateFormat="MM/yyyy"
                  showMonthYearPicker
                  className="dateChooser"
                />
              </div>
            </div>
          <ul class="levelMenu">
            {teamFilterShow
              ? BrandsTypes.map((item) => {
                  return (
                    <li
                      onClick={() => {
                        setselectedNewUserType(item.value);
                      }}
                      className={
                        selectedNewUserType === item.value ? "active" : ""
                      }
                    >
                      <i class="ico">
                        <img
                          src={
                            item.value === 1
                              ? nationalIcon
                              : item.value === 2
                              ? localIcon
                              : item.value === 3
                              ? metroIcon
                              : item.value === 4
                              ? localTNIcon
                              : alphaIcon
                          }
                          alt=""
                        />
                      </i>
                      <span>{item.label}</span>
                    </li>
                  );
                })
              : null}
          </ul>
        </div>

        {/* <!-- Tree Structure Start -->
      <!-- Leader Card --> */}
        {data?.length && !loader ? (
          <>
            {data.map((array, index) => {
              if (array.length) {
                if (index === 0) {
                  return array.map((item) => (
                    <div class="leaderCard active"
                    onClick={() => {
                      handleMoveToEffort(item.sales_person_id);
                    }}
                    >
                      <div class="proPic">
                        <img src={salesProfile} alt="" />
                      </div>
                      {/* <label class="level">Level - 2</label> */}
                      <div class="profDetails">
                        <h1>{capitalizeFirstLetter(item.name)}</h1>
                        <h4>{item.designation}</h4>
                      </div>
                    </div>
                  ));
                } else {
                  return (
                    <div
                      class={`${mainLevelClasses[index]}`}
                      id="national-sub-tree"
                    >
                      {array.map((item) => {
                        let active = false;
                        data.map((tempArray) =>
                          tempArray
                            .map((item) => item.sales_person_id)
                            .find((sales_person_id) => {
                              if (
                                item.subordinates.includes(sales_person_id) &&
                                !active
                              )
                                active = true;
                            })
                        );
                        return (
                          <div
                            class={`sub-card ${subLevelClasses[index]} ${
                              active ? "active" : ""
                            }`}
                          >
                            <div
                              class="card"
                              id={
                                index === data.length - 1 ? "scrollToEnd" : null
                              }
                              onClick={() => {
                                handleMoveToEffort(item.sales_person_id);
                              }}
                            >
                              <div class="proPic">
                                <img src={salesProfile} alt="" />
                              </div>
                              {/* <label class="level">North</label> */}
                              <div class="team">
                                {item.brands_count}
                                <sup>+</sup>
                              </div>
                              <div class="profDetails">
                                <h1>{capitalizeFirstLetter(item.name)}</h1>
                                <h4>{item.designation}</h4>
                                <ul class="recentActivity">
                                  <li class="direct-meeting">
                                    <i class="icon">
                                      <span>
                                        {item.interactions.find(
                                          (typeItem) => typeItem.type === 1
                                        )?.count || 0}
                                      </span>
                                    </i>
                                  </li>
                                  <li class="virtual-meeting">
                                    <i class="icon">
                                      <span>
                                        {item.interactions.find(
                                          (typeItem) => typeItem.type === 2
                                        )?.count || 0}
                                      </span>
                                    </i>
                                  </li>
                                  <li class="phone-call">
                                    <i class="icon">
                                      <span>
                                        {item.interactions.find(
                                          (typeItem) => typeItem.type === 3
                                        )?.count || 0}
                                      </span>
                                    </i>
                                  </li>
                                  <li class="whatsapp-chat">
                                    <i class="icon">
                                      <span>
                                        {item.interactions.find(
                                          (typeItem) => typeItem.type === 4
                                        )?.count || 0}
                                      </span>
                                    </i>
                                  </li>
                                  <li class="email-chat">
                                    <i class="icon">
                                      <span>
                                        {item.interactions.find(
                                          (typeItem) => typeItem.type === 5
                                        )?.count || 0}
                                      </span>
                                    </i>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            {item.subordinates?.length ? (
                              <div
                                class="count"
                                onClick={() => {
                                  if (!active) {
                                    handleElaborate(
                                      item.subordinates,
                                      item.sales_person_id
                                    );
                                  } else {
                                    setData(
                                      data.filter(
                                        (item, tempindex) => tempindex <= index
                                      )
                                    );
                                  }
                                }}
                              >
                                {item.subordinates?.length}
                              </div>
                            ) : null}
                            <button
                              onClick={() => {
                                handleMoveToEffort(item.sales_person_id);
                              }}
                              className="link"
                            >
                              <img src={linkIcon} alt="link" />
                            </button>
                          </div>
                        );
                      })}
                    </div>
                  );
                }
              }
            })}
          </>
        ) : !data?.length && !loader ? (
          <div className="w-full h-full d-flex justify-center">
            <NoDataFound />
          </div>
        ) : (
          <div className="w-full h-full d-flex justify-center">
            <TableLoader />
          </div>
        )}
      </div>
    </div> : null}
    {showEffort ? <EffortAnalysis setShowEffort={setShowEffort} salesPerson_id={sales_person_id} selectedMonth={selectedMonth}/> : null}
    </>
  );
}

export default EffortAnalysisDashboard;
